import axios from "@main/axios";
import {getPhoneMasked, getInputNumberValue} from "@main/helpers";
import {emailReg, MODAL_AUTO_CLOSE_TIMEOUT, TEL_VALUE_MIN_LENGH} from "@main/constants";

export class FormValidation {
    constructor(el) {
        this.el = el;
        this.action = this.el.getAttribute("action") || this.el.dataset.action;
        if (this.el.dataset.resultModal) {
            this.resultModal = document.querySelector(`.js-modal[data-modal="${this.el.dataset.resultModal}"]`);
        }
        this.fields = this.el.querySelectorAll("input, textarea");
        this.getRequiredFields();
        this.emailFields = this.el.querySelectorAll("input[type='email']");
        this.telFields = this.el.querySelectorAll("input[type='tel']");
        this.submitBtn = this.el.querySelector(".js-form-submit");
        this.errorMessageText = this.el.querySelector(".js-message-error-text");
        this.defaultError = this.errorMessageText?.dataset.defaultError || "Пожалуйста, заполните все поля!";
        this.emailError = this.errorMessageText?.dataset.emailError || "Не верный email";
        this.modal = this.el.closest(".js-modal");
        this.customSuccess = this.el.dataset.customSuccess;
        this.clearSuccess = this.el.dataset.clearSuccess;
        this.initEvents();
    }

    getRequiredFields() {
        this.requiredFields = this.el.querySelectorAll(
            "input[required], textarea[required]"
        );
    }

    initEvents() {
        if (this.telFields.length) {
            getPhoneMasked(this.telFields);
        }

        this.el.addEventListener("input", (e) => {
            this.checkInputValidity(e.target);
        });

        this.requiredFields.forEach((input) => {
            input.addEventListener("checkInputValidity", () => {
                this.checkInputValidity(input);
            });
        });

        this.el.addEventListener("submit", (e) => {
            e.preventDefault();
            if (this.checkAllError()) {
                this.sendFormData();
            }
        });

        this.el.addEventListener("checkAllError", () => {
            this.checkAllError();
        });
    }

    sendFormData = async () => {
        try {
            if (this.el.classList.contains("waiting")) {
                return;
            }
            this.el.classList.add("waiting");
            const response = await axios.post(
                this.action,
                new FormData(this.el)
            );
            this.el.classList.remove("waiting");

            if (!response?.data) {
                alert(
                    "Что-то пошло не так...\nПожалуйста, перезагрузите страницу."
                );
                return;
            }

            if (response.data.success) {
                this.el.classList.add("success");
                this.el.classList.remove("error");
                if (response.data.data?.successUrl) {
                    window.location.href = response.data.data.successUrl;
                }
                if (response.data.data?.successClose && this.modal) {
                    setTimeout(() => {
                        this.modal.dispatchEvent(new CustomEvent("closeModal"));
                    }, MODAL_AUTO_CLOSE_TIMEOUT);
                }
                if (this.resultModal) {
                    this.resultModal.dispatchEvent(new CustomEvent("openModal"));
                    if (response.data.data?.successClose) {
                        setTimeout(() => {
                            this.resultModal.dispatchEvent(new CustomEvent("closeModal"));
                        }, MODAL_AUTO_CLOSE_TIMEOUT);
                    }
                }
                if (this.customSuccess) {
                    this.el.dispatchEvent(new CustomEvent("formSuccess", {
                        detail: response.data
                    }));
                }
                if (this.clearSuccess) {
                    this.clearFields();
                }
            } else {
                this.el.classList.add("error");
                this.el.classList.remove("success");
                this.submitBtn.disabled = true;

                if (this.errorMessageText) {
                    this.errorMessageText.innerHTML = response.data.message || this.defaultError;
                }

                const fields = await response?.data?.data?.fields;

                if (!fields) {
                    return;
                }

                Array.from(fields).forEach((item) => {
                    const field = this.el.querySelector(
                        "input[name='" + item.name + "']"
                    );
                    this.addErrorToInput(field, item.message);
                });
            }
        } catch (error) {
            alert(error);
            this.el.classList.remove("waiting");
        }
    };

    checkInputValidity(input) {
        let error = false;
        if (input.required && this.checkFieldValueByType(input)) {
            error = true;
        } else if (input.value.trim()) {
            if (input.type === "tel" && getInputNumberValue(input).length < TEL_VALUE_MIN_LENGH) {
                error = true;
            } else if (input.type === "email" && !emailReg.test(input.value)) {
                error = true;
            }
        }
        if (!error) {
            this.removeInputError(input);
        } else {
            if (input.type === "email") {
                this.errorMessageText.innerHTML = this.emailError;
            } else {
                this.errorMessageText.innerHTML = this.defaultError;
            }
        }
        if (!this.el.querySelectorAll(".input--error").length) {
            this.el.classList.remove("error");
            this.submitBtn.disabled = false;
        }
    }

    checkAllError() {
        this.removeAllInputError();
        const empty = [...this.requiredFields].filter((field) => this.checkFieldValueByType(field));
        const emails = [...this.emailFields].filter((field) => !emailReg.test(field.value));
        const tel = [...this.telFields].filter((field) => field.value && getInputNumberValue(field).length < TEL_VALUE_MIN_LENGH);
        const result = [...empty, ...emails, ...tel];
        if (result.length) {
            result.forEach((input) => {
                this.addErrorToInput(input);
            });
            this.el.classList.add("error");
            if (this.errorMessageText) {
                if (emails.length && !empty.length) {
                    this.errorMessageText.innerHTML = this.emailError;
                } else {
                    this.errorMessageText.innerHTML = this.defaultError;
                }
            }
            this.submitBtn.disabled = true;
            return false;
        } else {
            this.el.classList.remove("error");
            this.submitBtn.disabled = false;
            return true;
        }
    }

    checkFieldValueByType(field) {
        return (field.value.trim() === "" && field.type !== "radio" && field.type !== "checkbox")
        ||
        (!field.checked && (field.type === "radio" || field.type === "checkbox"))
    }

    hideMessage() {
        this.el.classList.remove("success");
        this.el.classList.remove("error");
    }

    addErrorToInput(field, message = "") {
        const input = field?.closest(".input");
        const error = input?.querySelector(".input__error");
        if (input) {
            input.classList.add("input--error");
        }
        if (error && message) {
            error.innerHTML = message;
        }
    }

    removeAllInputError() {
        this.el.querySelectorAll(".input--error").forEach((item) => {
            item.classList.remove("input--error");
        });
    }

    removeInputError(input) {
        const field = input?.closest(".input");
        if (field) {
            field.classList.remove("input--error");
        }
    }

    clearFields() {
        this.fields.forEach((field) => {
            field.value = "";
        });
    }
}

document
    .querySelectorAll(".js-form-validate")
    .forEach((form) => new FormValidation(form));
